import PropTypes from 'prop-types';

const Pilot = {
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  licenseNumber: PropTypes.string.isRequired,
  isDeleted: PropTypes.bool,
};

export const PilotShape = PropTypes.shape(Pilot);
export const PilotExact = PropTypes.exact(Pilot);
